export const COUNTRIES = [
  {
    primaryCode: "en",
    secondaryCode: "us",
    native: "American English",
    name: "American English",
    code: "en-us"
  },
  {
    primaryCode: "aau",
    native: "Abau",
    name: "Abau",
    secondaryCode: "",
    code: "aau"
  },
  {
    primaryCode: "abq",
    native: "Абаза Бызшва",
    name: "Abaza",
    secondaryCode: "",
    code: "abq"
  },
  {
    primaryCode: "ab",
    native: "Aҧсуа бызшәа",
    name: "Abkhaz",
    secondaryCode: "",
    code: "ab"
  },
  {
    primaryCode: "fr",
    secondaryCode: "ac",
    native: "Acadien",
    name: "Acadian French",
    code: "fr-ac"
  },
  {
    primaryCode: "ace",
    native: "Basa Acèh",
    name: "Acehnese",
    secondaryCode: "",
    code: "ace"
  },
  {
    primaryCode: "ady",
    native: "Адыгaбзэ",
    name: "Adyghe",
    secondaryCode: "",
    code: "ady"
  },
  {
    primaryCode: "af",
    native: "Afrikaans",
    name: "Afrikaans",
    secondaryCode: "",
    code: "af"
  },
  {
    primaryCode: "agx",
    native: "агъул чӀал",
    name: "Aghul",
    secondaryCode: "",
    code: "agx"
  },
  {
    primaryCode: "ain",
    native: "アイヌイタク",
    name: "Ainu",
    secondaryCode: "",
    code: "ain"
  },
  {
    primaryCode: "akv",
    native: "Ашвaлъи мицIи",
    name: "Akhvakh",
    secondaryCode: "",
    code: "akv"
  },
  {
    primaryCode: "akk",
    native: "lišānum akkadītum",
    name: "Akkadian",
    secondaryCode: "",
    code: "akk"
  },
  {
    primaryCode: "sq",
    native: "Shqipe",
    name: "Albanian",
    secondaryCode: "",
    code: "sq"
  },
  {
    primaryCode: "ale",
    native: "Unangam Tunuu",
    name: "Aleut",
    secondaryCode: "",
    code: "ale"
  },
  {
    primaryCode: "alq",
    native: "Anicinâbemowin",
    name: "Algonquin",
    secondaryCode: "",
    code: "alq"
  },
  {
    primaryCode: "atv",
    native: "Алтай",
    name: "Altay, Northern",
    secondaryCode: "",
    code: "atv"
  },
  {
    primaryCode: "alt",
    native: "Алтай",
    name: "Altay, Southern",
    secondaryCode: "",
    code: "alt"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "us",
    native: "American Sign Language",
    name: "American Sign Language",
    code: "sgn-us"
  },
  {
    primaryCode: "am",
    native: "አማርኛ",
    name: "Amharic",
    secondaryCode: "",
    code: "am"
  },
  {
    primaryCode: "es",
    secondaryCode: "an",
    native: "Español de Andalucía",
    name: "Andalusian Spanish",
    code: "es-an"
  },
  {
    primaryCode: "ani",
    native: "къIaваннаб мицци",
    name: "Andi",
    secondaryCode: "",
    code: "ani"
  },
  {
    primaryCode: "xno",
    native: "Anglo-normand",
    name: "Anglo-Norman",
    secondaryCode: "",
    code: "xno"
  },
  {
    primaryCode: "apw",
    native: "Nṉēē biyáti’",
    name: "Apache (Western)",
    secondaryCode: "",
    code: "apw"
  },
  {
    primaryCode: "ar",
    native: "العربية",
    name: "Arabic",
    secondaryCode: "",
    code: "ar"
  },
  {
    primaryCode: "ar",
    secondaryCode: "dz",
    native: "العربية - اللهجة الجزائرية",
    name: "Arabic, Algerian",
    code: "ar-dz"
  },
  {
    primaryCode: "ar",
    secondaryCode: "acy",
    native: "Sanna",
    name: "Arabic, Cypriot Maronite",
    code: "ar-acy"
  },
  {
    primaryCode: "ar",
    secondaryCode: "eg",
    native: "العربية - اللهجة المصرية",
    name: "Arabic, Egyptian",
    code: "ar-eg"
  },
  {
    primaryCode: "ar",
    secondaryCode: "afb",
    native: "العربية - اللهجة الخليجية",
    name: "Arabic, Gulf",
    code: "ar-afb"
  },
  {
    primaryCode: "ar",
    secondaryCode: "iq",
    native: "العربية - اللهجة العراقية",
    name: "Arabic, Iraqi",
    code: "ar-iq"
  },
  {
    primaryCode: "ar",
    secondaryCode: "lb",
    native: "العربية - اللهجة اللبنانية",
    name: "Arabic, Lebanese",
    code: "ar-lb"
  },
  {
    primaryCode: "ar",
    secondaryCode: "apc",
    native: "العربية - اللهجة الشامية",
    name: "Arabic, Levantine",
    code: "ar-apc"
  },
  {
    primaryCode: "ar",
    secondaryCode: "ly",
    native: "العربية - اللهجة الشامية",
    name: "Arabic, Libyan",
    code: "ar-ly"
  },
  {
    primaryCode: "ar",
    secondaryCode: "ma",
    native: "العربية - اللهجة المغربية",
    name: "Arabic, Moroccan",
    code: "ar-ma"
  },
  {
    primaryCode: "ar",
    secondaryCode: "sa",
    native: "العربية - اللهجة السعودية",
    name: "Arabic, Saudi Arabian",
    code: "ar-sa"
  },
  {
    primaryCode: "ar",
    secondaryCode: "arb",
    native: "العربية - الفصحى",
    name: "Arabic, Standard",
    code: "ar-arb"
  },
  {
    primaryCode: "ar",
    secondaryCode: "sd",
    native: "العربية - اللهجة السودانية",
    name: "Arabic, Sudanese",
    code: "ar-sd"
  },
  {
    primaryCode: "ar",
    secondaryCode: "tn",
    native: "العربية - اللهجة التونسية",
    name: "Arabic, Tunesian",
    code: "ar-tn"
  },
  {
    primaryCode: "an",
    native: "Aragones",
    name: "Aragonese",
    secondaryCode: "",
    code: "an"
  },
  {
    primaryCode: "arc",
    native: "אַרָמִית",
    name: "Aramaic",
    secondaryCode: "",
    code: "arc"
  },
  {
    primaryCode: "arp",
    native: "Hinóno'eitíít",
    name: "Arapaho",
    secondaryCode: "",
    code: "arp"
  },
  {
    primaryCode: "arw",
    native: "Arawak",
    name: "Arawak",
    secondaryCode: "",
    code: "arw"
  },
  {
    primaryCode: "aqc",
    native: "Archi",
    name: "Archi",
    secondaryCode: "",
    code: "aqc"
  },
  {
    primaryCode: "es",
    secondaryCode: "ar",
    native: "Español de Argentina",
    name: "Argentinian Spanish",
    code: "es-ar"
  },
  {
    primaryCode: "ari",
    native: "Sániš",
    name: "Arikara",
    secondaryCode: "",
    code: "ari"
  },
  {
    primaryCode: "hy",
    native: "Հայերեն",
    name: "Armenian",
    secondaryCode: "",
    code: "hy"
  },
  {
    primaryCode: "hy",
    secondaryCode: "e",
    native: "արևելահայերեն",
    name: "Armenian, Eastern",
    code: "hy-e"
  },
  {
    primaryCode: "hy",
    secondaryCode: "h",
    native: "Հոմշեցի",
    name: "Armenian, Homshetsi",
    code: "hy-h"
  },
  {
    primaryCode: "hy",
    secondaryCode: "w",
    native: "Արեւմտահայերէն",
    name: "Armenian, Western",
    code: "hy-w"
  },
  {
    primaryCode: "rup",
    native: "Armãneashce",
    name: "Aromanian",
    secondaryCode: "",
    code: "rup"
  },
  {
    primaryCode: "aer",
    native: "Arrernte angkentye",
    name: "Arrernte",
    secondaryCode: "",
    code: "aer"
  },
  {
    primaryCode: "as",
    native: "অসিময়া",
    name: "Assamese",
    secondaryCode: "",
    code: "as"
  },
  {
    primaryCode: "ast",
    native: "Asturianu",
    name: "Asturian",
    secondaryCode: "",
    code: "ast"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "au",
    native: "Auslan",
    name: "Auslan",
    code: "sgn-au"
  },
  {
    primaryCode: "en",
    secondaryCode: "au",
    native: "Australian English",
    name: "Australian English",
    code: "en-au"
  },
  {
    primaryCode: "de",
    secondaryCode: "at",
    native: "Österreichisch",
    name: "Austrian German",
    code: "de-at"
  },
  {
    primaryCode: "av",
    native: "Авар мацІ",
    name: "Avar",
    secondaryCode: "",
    code: "av"
  },
  {
    primaryCode: "ae",
    native: "Avestan",
    name: "Avestan",
    secondaryCode: "",
    code: "ae"
  },
  {
    primaryCode: "ay",
    native: "Aymará",
    name: "Aymara",
    secondaryCode: "",
    code: "ay"
  },
  {
    primaryCode: "az",
    native: "Azərbaycanca",
    name: "Azerbaijani",
    secondaryCode: "",
    code: "az"
  },
  {
    primaryCode: "kva",
    native: "Bagvalal",
    name: "Bagvalal",
    secondaryCode: "",
    code: "kva"
  },
  {
    primaryCode: "ban",
    native: "Basa Bali",
    name: "Balinese",
    secondaryCode: "",
    code: "ban"
  },
  {
    primaryCode: "bm",
    native: "Bambara",
    name: "Bamanankan",
    secondaryCode: "",
    code: "bm"
  },
  {
    primaryCode: "jv",
    secondaryCode: "bms",
    native: "Basa Banyumasan",
    name: "Banyumasan",
    code: "jv-bms"
  },
  {
    primaryCode: "ba",
    native: "Башҡортса",
    name: "Bashkir",
    secondaryCode: "",
    code: "ba"
  },
  {
    primaryCode: "eu",
    native: "Euskara",
    name: "Basque",
    secondaryCode: "",
    code: "eu"
  },
  {
    primaryCode: "bbl",
    native: "batsba motjiti",
    name: "Bats",
    secondaryCode: "",
    code: "bbl"
  },
  {
    primaryCode: "be",
    native: "Беларускі",
    name: "Belarusian",
    secondaryCode: "",
    code: "be"
  },
  {
    primaryCode: "be",
    secondaryCode: "tara",
    native: "тарашкевіца",
    name: "Belarusian [Taraškievica]",
    code: "be-tara"
  },
  {
    primaryCode: "fr",
    secondaryCode: "be",
    native: "Français Belge",
    name: "Belgian French",
    code: "fr-be"
  },
  {
    primaryCode: "bn",
    native: "বাংলা",
    name: "Bengali",
    secondaryCode: "",
    code: "bn"
  },
  {
    primaryCode: "bue",
    native: "Beothukan",
    name: "Beothuk",
    secondaryCode: "",
    code: "bue"
  },
  {
    primaryCode: "ber",
    native: "Berber",
    name: "Berber",
    secondaryCode: "",
    code: "ber"
  },
  {
    primaryCode: "kap",
    native: "бежкьалас миц",
    name: "Bezhta",
    secondaryCode: "",
    code: "kap"
  },
  {
    primaryCode: "bpy",
    native: "ইমার ঠার/বিষ্ণুপ্রিয়া মণিপুরী",
    name: "Bishnupriya Manipuri",
    secondaryCode: "",
    code: "bpy"
  },
  {
    primaryCode: "bis",
    native: "Bislama",
    name: "Bislama",
    secondaryCode: "",
    code: "bis"
  },
  {
    primaryCode: "bla",
    native: "Siksiká",
    name: "Blackfoot",
    secondaryCode: "",
    code: "bla"
  },
  {
    primaryCode: "brx",
    native: "बड़ो",
    name: "Bodo",
    secondaryCode: "",
    code: "brx"
  },
  {
    primaryCode: "es",
    secondaryCode: "bo",
    native: "Español de Bolivia",
    name: "Bolivian Spanish",
    code: "es-bo"
  },
  {
    primaryCode: "bs",
    native: "Bosanski",
    name: "Bosnian",
    secondaryCode: "",
    code: "bs"
  },
  {
    primaryCode: "bph",
    native: "Буйхaлъи мицIцIи",
    name: "Botlikh",
    secondaryCode: "",
    code: "bph"
  },
  {
    primaryCode: "pt",
    secondaryCode: "br",
    native: "Português do Brasil",
    name: "Brazilian Portuguese",
    code: "pt-br"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "br",
    native: "LIBRAS",
    name: "Brazilian Sign Language",
    code: "sgn-br"
  },
  {
    primaryCode: "br",
    native: "Brezhoneg",
    name: "Breton",
    secondaryCode: "",
    code: "br"
  },
  {
    primaryCode: "en",
    secondaryCode: "gb",
    native: "British English",
    name: "British English",
    code: "en-gb"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "gb",
    native: "British Sign Language",
    name: "British Sign Language",
    code: "sgn-gb"
  },
  {
    primaryCode: "bdk",
    native: "Будад мез",
    name: "Budukh",
    secondaryCode: "",
    code: "bdk"
  },
  {
    primaryCode: "bug",
    native: "Basa Ugi",
    name: "Buginese",
    secondaryCode: "",
    code: "bug"
  },
  {
    primaryCode: "bg",
    native: "Български",
    name: "Bulgarian",
    secondaryCode: "",
    code: "bg"
  },
  {
    primaryCode: "my",
    native: "မ္ရန္မာ",
    name: "Burmese",
    secondaryCode: "",
    code: "my"
  },
  {
    primaryCode: "bsk",
    native: "بروشسکی",
    name: "Burushaski",
    secondaryCode: "",
    code: "bsk"
  },
  {
    primaryCode: "bua",
    native: "буряад",
    name: "Buryat",
    secondaryCode: "",
    code: "bua"
  },
  {
    primaryCode: "fr",
    secondaryCode: "frc",
    native: "Français Cadien",
    name: "Cajun French",
    code: "fr-frc"
  },
  {
    primaryCode: "en",
    secondaryCode: "ca",
    native: "Canadian English",
    name: "Canadian English",
    code: "en-ca"
  },
  {
    primaryCode: "fr",
    secondaryCode: "ca",
    native: "Français du Canada",
    name: "Canadian French",
    code: "fr-ca"
  },
  {
    primaryCode: "yue",
    secondaryCode: "hans",
    native: "粤语",
    name: "Cantonese [Simplified script]",
    code: "yue-hans"
  },
  {
    primaryCode: "yue",
    secondaryCode: "hant",
    native: "粵語",
    name: "Cantonese [Traditional script]",
    code: "yue-hant"
  },
  {
    primaryCode: "kea",
    native: "Kriólu Kabuberdiánu",
    name: "Cape Verdean Creole",
    secondaryCode: "",
    code: "kea"
  },
  {
    primaryCode: "ca",
    native: "Català",
    name: "Catalan",
    secondaryCode: "",
    code: "ca"
  },
  {
    primaryCode: "cay",
    native: "Gayogohó:nǫ’",
    name: "Cayuga",
    secondaryCode: "",
    code: "cay"
  },
  {
    primaryCode: "ceb",
    native: "Cebuano",
    name: "Cebuano",
    secondaryCode: "",
    code: "ceb"
  },
  {
    primaryCode: "tzm",
    native: "ⵜⴰⵎⴰⵣⵉⵖⵜ",
    name: "Central Atlas Tamazight",
    secondaryCode: "",
    code: "tzm"
  },
  {
    primaryCode: "chg",
    native: "جغتای",
    name: "Chagatai",
    secondaryCode: "",
    code: "chg"
  },
  {
    primaryCode: "cji",
    native: "чамалалдуб мичIчI",
    name: "Chamalal",
    secondaryCode: "",
    code: "cji"
  },
  {
    primaryCode: "ch",
    native: "Chamoru",
    name: "Chamorro",
    secondaryCode: "",
    code: "ch"
  },
  {
    primaryCode: "ce",
    native: "Нохчийн мотт",
    name: "Chechen",
    secondaryCode: "",
    code: "ce"
  },
  {
    primaryCode: "chr",
    native: "ᏣᎳᎩ",
    name: "Cherokee",
    secondaryCode: "",
    code: "chr"
  },
  {
    primaryCode: "ny",
    native: "Nyanja",
    name: "Chewa",
    secondaryCode: "",
    code: "ny"
  },
  {
    primaryCode: "chy",
    native: "Tsétsêhéstâhese",
    name: "Cheyenne",
    secondaryCode: "",
    code: "chy"
  },
  {
    primaryCode: "es",
    secondaryCode: "cl",
    native: "Español de Chile",
    name: "Chilean Spanish",
    code: "es-cl"
  },
  {
    primaryCode: "zh",
    secondaryCode: "",
    native: "汉语",
    name: "Chinese [Simplified]",
    code: "zh"
  },
  {
    primaryCode: "zh",
    secondaryCode: "hant",
    native: "漢語",
    name: "Chinese [Traditional]",
    code: "zh-tw"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "cn",
    native: "中国手语",
    name: "Chinese Sign Language",
    code: "sgn-cn"
  },
  {
    primaryCode: "chn",
    native: "Chinook wawa",
    name: "Chinook Jargon",
    secondaryCode: "",
    code: "chn"
  },
  {
    primaryCode: "cho",
    native: "Chahta Anumpa",
    name: "Choctaw",
    secondaryCode: "",
    code: "cho"
  },
  {
    primaryCode: "ckt",
    native: "Ԓыгъоравэтԓьэн йиԓыйиԓ",
    name: "Chukchi",
    secondaryCode: "",
    code: "ckt"
  },
  {
    primaryCode: "cv",
    native: "чӑваш чӗлхи",
    name: "Chuvash",
    secondaryCode: "",
    code: "cv"
  },
  {
    primaryCode: "cim",
    native: "Tzimbris",
    name: "Cimbrian",
    secondaryCode: "",
    code: "cim"
  },
  {
    primaryCode: "hy",
    secondaryCode: "clas",
    native: "գրաբար",
    name: "Classical Armenian",
    code: "hy-clas"
  },
  {
    primaryCode: "zhc",
    native: "文言文",
    name: "Classical Chinese",
    secondaryCode: "",
    code: "zhc"
  },
  {
    primaryCode: "ja",
    secondaryCode: "clas",
    native: "和文",
    name: "Classical Japanese",
    code: "ja-clas"
  },
  {
    primaryCode: "cmg",
    native: "Mongɣol kele",
    name: "Classical Mongolian",
    secondaryCode: "",
    code: "cmg"
  },
  {
    primaryCode: "bod",
    native: "བོད་སྐད་",
    name: "Classical Tibetan",
    secondaryCode: "",
    code: "bod"
  },
  {
    primaryCode: "crd",
    native: "Snchitsuʼumshtsn",
    name: "Coeur d'Alene Salish",
    secondaryCode: "",
    code: "crd"
  },
  {
    primaryCode: "es",
    secondaryCode: "co",
    native: "Español de Colombia",
    name: "Colombian Spanish",
    code: "es-co"
  },
  {
    primaryCode: "oka",
    native: "Nsəlxcin",
    name: "Colville-Okanagan Salish",
    secondaryCode: "",
    code: "oka"
  },
  {
    primaryCode: "art",
    native: "Constructed Language",
    name: "Constructed Language",
    secondaryCode: "",
    code: "art"
  },
  {
    primaryCode: "rar",
    native: "Māori Kūki 'Āirani",
    name: "Cook Islands Māori",
    secondaryCode: "",
    code: "rar"
  },
  {
    primaryCode: "cop",
    native: "ⲙⲛⲧⲣⲙⲛⲕⲏⲙⲉ",
    name: "Coptic",
    secondaryCode: "",
    code: "cop"
  },
  {
    primaryCode: "kw",
    native: "Kernewek",
    name: "Cornish",
    secondaryCode: "",
    code: "kw"
  },
  {
    primaryCode: "co",
    native: "Corsu",
    name: "Corsican",
    secondaryCode: "",
    code: "co"
  },
  {
    primaryCode: "es",
    secondaryCode: "cr",
    native: "Español de Costa Rica",
    name: "Costa Rican Spanish",
    code: "es-cr"
  },
  {
    primaryCode: "cr",
    native: "ᓂᐦᔭᐘᒃ",
    name: "Cree",
    secondaryCode: "",
    code: "cr"
  },
  {
    primaryCode: "mus",
    native: "Mvskoke",
    name: "Creek",
    secondaryCode: "",
    code: "mus"
  },
  {
    primaryCode: "crh",
    native: "Qırımtatar tili",
    name: "Crimean Tatar",
    secondaryCode: "",
    code: "crh"
  },
  {
    primaryCode: "hr",
    native: "Hrvatski",
    name: "Croatian",
    secondaryCode: "",
    code: "hr"
  },
  {
    primaryCode: "es",
    secondaryCode: "cu",
    native: "Español de Cuba",
    name: "Cuban Spanish",
    code: "es-cu"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "cy",
    native: "Κυπριακή Νοηματική Γλώσσα",
    name: "Cyprus Sign Language",
    code: "sgn-cy"
  },
  {
    primaryCode: "cs",
    native: "Čeština",
    name: "Czech",
    secondaryCode: "",
    code: "cs"
  },
  {
    primaryCode: "dak",
    native: "Dakȟótiyapi",
    name: "Dakota",
    secondaryCode: "",
    code: "dak"
  },
  {
    primaryCode: "dlc",
    native: "Dalska",
    name: "Dalecarlian",
    secondaryCode: "",
    code: "dlc"
  },
  {
    primaryCode: "da",
    native: "Dansk",
    name: "Danish",
    secondaryCode: "",
    code: "da"
  },
  {
    primaryCode: "dar",
    native: "дарган мез",
    name: "Dargwa",
    secondaryCode: "",
    code: "dar"
  },
  {
    primaryCode: "fa",
    secondaryCode: "af",
    native: "درى",
    name: "Dari",
    code: "fa-af"
  },
  {
    primaryCode: "unm",
    native: "Lenape",
    name: "Delaware",
    secondaryCode: "",
    code: "unm"
  },
  {
    primaryCode: "tfn",
    native: "Dena’ina qenaga",
    name: "Dena'ina",
    secondaryCode: "",
    code: "tfn"
  },
  {
    primaryCode: "dv",
    native: "ދިވެހިބަސ",
    name: "Dhivehi",
    secondaryCode: "",
    code: "dv"
  },
  {
    primaryCode: "din",
    native: "Thuɔŋjäŋ",
    name: "Dinka",
    secondaryCode: "",
    code: "din"
  },
  {
    primaryCode: "dgr",
    native: "Tłı̨chǫ Yatıì",
    name: "Dogrib",
    secondaryCode: "",
    code: "dgr"
  },
  {
    primaryCode: "es",
    secondaryCode: "do",
    native: "Español de la República Dominicana",
    name: "Dominican Spanish",
    code: "es-do"
  },
  {
    primaryCode: "dng",
    native: "Хуэйзў йүян",
    name: "Dungan",
    secondaryCode: "",
    code: "dng"
  },
  {
    primaryCode: "nl",
    native: "Nederlands",
    name: "Dutch",
    secondaryCode: "",
    code: "nl"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "nl",
    native: "NGT",
    name: "Dutch Sign Language",
    code: "sgn-nl"
  },
  {
    primaryCode: "nl",
    secondaryCode: "nbr",
    native: "Braobans",
    name: "Dutch, Brabantian",
    code: "nl-nbr"
  },
  {
    primaryCode: "dz",
    native: "༄༅ཇོ༹ང་ཁ",
    name: "Dzongkha",
    secondaryCode: "",
    code: "dz"
  },
  {
    primaryCode: "la",
    secondaryCode: "va",
    native: "Lingua Latina Ecclesiastica",
    name: "Ecclesiastical Latin",
    code: "la-va"
  },
  {
    primaryCode: "egy",
    native: "Egyptian, ancient",
    name: "Egyptian, ancient",
    secondaryCode: "",
    code: "egy"
  },
  {
    primaryCode: "elx",
    native: "Elamite",
    name: "Elamite",
    secondaryCode: "",
    code: "elx"
  },
  {
    primaryCode: "egl",
    native: "Emigliàn",
    name: "Emiliano",
    secondaryCode: "",
    code: "egl"
  },
  {
    primaryCode: "enq",
    native: "Enga",
    name: "Enga",
    secondaryCode: "",
    code: "enq"
  },
  {
    primaryCode: "en",
    native: "English",
    name: "English",
    secondaryCode: "",
    code: "en"
  },
  {
    primaryCode: "myv",
    native: "Эрзянь",
    name: "Erzya",
    secondaryCode: "",
    code: "myv"
  },
  {
    primaryCode: "eo",
    native: "Esperanto",
    name: "Esperanto",
    secondaryCode: "",
    code: "eo"
  },
  {
    primaryCode: "et",
    native: "Eesti",
    name: "Estonian",
    secondaryCode: "",
    code: "et"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "ee",
    native: "Estonian Sign Language",
    name: "Estonian Sign Language",
    code: "sgn-ee"
  },
  {
    primaryCode: "ett",
    native: "mechl Rasnal",
    name: "Etruscan",
    secondaryCode: "",
    code: "ett"
  },
  {
    primaryCode: "pt",
    secondaryCode: "pt",
    native: "Português de Portugal",
    name: "European Portuguese",
    code: "pt-pt"
  },
  {
    primaryCode: "evn",
    native: "Эвэнки",
    name: "Evenki",
    secondaryCode: "",
    code: "evn"
  },
  {
    primaryCode: "ee",
    native: "Èʋegbe",
    name: "Ewe",
    secondaryCode: "",
    code: "ee"
  },
  {
    primaryCode: "ext",
    native: "Estremeñu",
    name: "Extremaduran",
    secondaryCode: "",
    code: "ext"
  },
  {
    primaryCode: "fo",
    native: "Føroyskt",
    name: "Faroese",
    secondaryCode: "",
    code: "fo"
  },
  {
    primaryCode: "hif",
    native: "Fiji Baat",
    name: "Fiji Hindi",
    secondaryCode: "",
    code: "hif"
  },
  {
    primaryCode: "fj",
    native: "Na vosa Vakaviti",
    name: "Fijian",
    secondaryCode: "",
    code: "fj"
  },
  {
    primaryCode: "sv",
    secondaryCode: "fi",
    native: "Finlandssvenska",
    name: "Finland Swedish",
    code: "sv-fi"
  },
  {
    primaryCode: "fi",
    native: "Suomi",
    name: "Finnish",
    secondaryCode: "",
    code: "fi"
  },
  {
    primaryCode: "nl",
    secondaryCode: "be",
    native: "Vlaams",
    name: "Flemish",
    code: "nl-be"
  },
  {
    primaryCode: "frp",
    native: "arpetan",
    name: "Franco-Provençal",
    secondaryCode: "",
    code: "frp"
  },
  {
    primaryCode: "fr",
    native: "Français",
    name: "French",
    secondaryCode: "",
    code: "fr"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "fr",
    native: "LSF",
    name: "French Sign Language",
    code: "sgn-fr"
  },
  {
    primaryCode: "fur",
    native: "Furlan",
    name: "Friulian",
    secondaryCode: "",
    code: "fur"
  },
  {
    primaryCode: "gag",
    native: "Gagauz dili",
    name: "Gagauz",
    secondaryCode: "",
    code: "gag"
  },
  {
    primaryCode: "gl",
    native: "Galego",
    name: "Galician",
    secondaryCode: "",
    code: "gl"
  },
  {
    primaryCode: "gan",
    secondaryCode: "hans",
    native: "赣语",
    name: "Gan Chinese [Simplified script]",
    code: "gan-hans"
  },
  {
    primaryCode: "gan",
    secondaryCode: "hant",
    native: "赣語",
    name: "Gan Chinese [Traditional script]",
    code: "gan-hant"
  },
  {
    primaryCode: "ka",
    native: "ქართული",
    name: "Georgian",
    secondaryCode: "",
    code: "ka"
  },
  {
    primaryCode: "de",
    native: "Deutsch",
    name: "German",
    secondaryCode: "",
    code: "de"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "de",
    native: "DGS",
    name: "German Sign Language",
    code: "sgn-de"
  },
  {
    primaryCode: "gez",
    native: "ግዕዝ",
    name: "Ge’ez",
    secondaryCode: "",
    code: "gez"
  },
  {
    primaryCode: "glk",
    native: "گیلکی",
    name: "Gilaki",
    secondaryCode: "",
    code: "glk"
  },
  {
    primaryCode: "gil",
    native: "Kiribati",
    name: "Gilbertese",
    secondaryCode: "",
    code: "gil"
  },
  {
    primaryCode: "gdo",
    native: "ГъибдилIи мицци",
    name: "Godoberi",
    secondaryCode: "",
    code: "gdo"
  },
  {
    primaryCode: "got",
    native: "Gutiska",
    name: "Gothic",
    secondaryCode: "",
    code: "got"
  },
  {
    primaryCode: "el",
    native: "Ελληνικά",
    name: "Greek",
    secondaryCode: "",
    code: "el"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "gr",
    native: "GSL",
    name: "Greek Sign Language",
    code: "sgn-gr"
  },
  {
    primaryCode: "el",
    secondaryCode: "cy",
    native: "Κυπριακά",
    name: "Greek, Cypriot",
    code: "el-cy"
  },
  {
    primaryCode: "el",
    secondaryCode: "ka",
    native: "Καθαρεύουσα",
    name: "Greek, Katharevousa",
    code: "el-ka"
  },
  {
    primaryCode: "grc",
    native: "Ἑλληνική",
    name: "Greek, ancient",
    secondaryCode: "",
    code: "grc"
  },
  {
    primaryCode: "kl",
    native: "Kalaallisut",
    name: "Greenlandic",
    secondaryCode: "",
    code: "kl"
  },
  {
    primaryCode: "grn",
    native: "Guaraní",
    name: "Guarani",
    secondaryCode: "",
    code: "grn"
  },
  {
    primaryCode: "es",
    secondaryCode: "gt",
    native: "Español de Guatemala",
    name: "Guatemalan Spanish",
    code: "es-gt"
  },
  {
    primaryCode: "gu",
    native: "ગુજરાતી",
    name: "Gujarati",
    secondaryCode: "",
    code: "gu"
  },
  {
    primaryCode: "hai",
    native: "X̲aat Kíl",
    name: "Haida",
    secondaryCode: "",
    code: "hai"
  },
  {
    primaryCode: "ht",
    native: "Krèyol",
    name: "Haitian Creole",
    secondaryCode: "",
    code: "ht"
  },
  {
    primaryCode: "hak",
    secondaryCode: "hans",
    native: "客家话",
    name: "Hakka [Simplified script]",
    code: "hak-hans"
  },
  {
    primaryCode: "hak",
    secondaryCode: "hant",
    native: "客家語",
    name: "Hakka [Traditional script]",
    code: "hak-hant"
  },
  {
    primaryCode: "hur",
    native: "Hul'q'umín'um'",
    name: "Halkomelem",
    secondaryCode: "",
    code: "hur"
  },
  {
    primaryCode: "ha",
    secondaryCode: "arab",
    native: "هَوُس",
    name: "Hausa [Arabic script]",
    code: "ha-arab"
  },
  {
    primaryCode: "ha",
    secondaryCode: "latn",
    native: "Hausa",
    name: "Hausa [Latin script]",
    code: "ha-latn"
  },
  {
    primaryCode: "haw",
    native: "`Ōlelo Hawai`i",
    name: "Hawaiian",
    secondaryCode: "",
    code: "haw"
  },
  {
    primaryCode: "he",
    native: "עברית",
    name: "Hebrew",
    secondaryCode: "",
    code: "he"
  },
  {
    primaryCode: "he",
    secondaryCode: "hbo",
    native: "עברית מקראית",
    name: "Hebrew, Biblical",
    code: "he-hbo"
  },
  {
    primaryCode: "hz",
    native: "Otjiherero",
    name: "Herero",
    secondaryCode: "",
    code: "hz"
  },
  {
    primaryCode: "hi",
    native: "हिन्दी",
    name: "Hindi",
    secondaryCode: "",
    code: "hi"
  },
  {
    primaryCode: "gin",
    native: "гьинузас мец",
    name: "Hinukh",
    secondaryCode: "",
    code: "gin"
  },
  {
    primaryCode: "ho",
    native: "Hiri Motu",
    name: "Hiri Motu",
    secondaryCode: "",
    code: "ho"
  },
  {
    primaryCode: "hit",
    native: "nešili",
    name: "Hittite",
    secondaryCode: "",
    code: "hit"
  },
  {
    primaryCode: "hmn",
    native: "Hmoob",
    name: "Hmong",
    secondaryCode: "",
    code: "hmn"
  },
  {
    primaryCode: "es",
    secondaryCode: "hn",
    native: "Español de Honduras",
    name: "Honduran Spanish",
    code: "es-hn"
  },
  {
    primaryCode: "hop",
    native: "Hopilavayi",
    name: "Hopi",
    secondaryCode: "",
    code: "hop"
  },
  {
    primaryCode: "czh",
    secondaryCode: "hans",
    native: "徽语",
    name: "Hui [Simplified script]",
    code: "czh-hans"
  },
  {
    primaryCode: "czh",
    secondaryCode: "hant",
    native: "徽語",
    name: "Hui [Traditional script]",
    code: "czh-hant"
  },
  {
    primaryCode: "hu",
    native: "Magyar",
    name: "Hungarian",
    secondaryCode: "",
    code: "hu"
  },
  {
    primaryCode: "huz",
    native: "гьонкьос мыц",
    name: "Hunzib",
    secondaryCode: "",
    code: "huz"
  },
  {
    primaryCode: "is",
    native: "Íslenska",
    name: "Icelandic",
    secondaryCode: "",
    code: "is"
  },
  {
    primaryCode: "art",
    secondaryCode: "ido",
    native: "Ido",
    name: "Ido",
    code: "art-ido"
  },
  {
    primaryCode: "ig",
    native: "Igbo",
    name: "Igbo",
    secondaryCode: "",
    code: "ig"
  },
  {
    primaryCode: "rn",
    native: "Kirundi",
    name: "Ikirundi",
    secondaryCode: "",
    code: "rn"
  },
  {
    primaryCode: "smi",
    secondaryCode: "smn",
    native: "anarâškielâ",
    name: "Inari Sami",
    code: "smi-smn"
  },
  {
    primaryCode: "id",
    native: "Bahasa Indonesia",
    name: "Indonesian",
    secondaryCode: "",
    code: "id"
  },
  {
    primaryCode: "inh",
    native: "гӀалгӀайн мотт",
    name: "Ingush",
    secondaryCode: "",
    code: "inh"
  },
  {
    primaryCode: "art",
    secondaryCode: "ina",
    native: "Interlingua",
    name: "Interlingua",
    code: "art-ina"
  },
  {
    primaryCode: "iu",
    native: "ᐃᓄᒃᑎᑐᑦ",
    name: "Inuktitut",
    secondaryCode: "",
    code: "iu"
  },
  {
    primaryCode: "en",
    secondaryCode: "ie",
    native: "Irish English",
    name: "Irish English",
    code: "en-ie"
  },
  {
    primaryCode: "ga",
    native: "Gaeilge",
    name: "Irish Gaelic",
    secondaryCode: "",
    code: "ga"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "ie",
    native: "Irish Sign Language",
    name: "Irish Sign Language",
    code: "sgn-ie"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "il",
    native: "שפת סימנים ישראלית",
    name: "Israeli Sign Language",
    code: "sgn-il"
  },
  {
    primaryCode: "it",
    native: "Italiano",
    name: "Italian",
    secondaryCode: "",
    code: "it"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "it",
    native: "LIS",
    name: "Italian Sign Language",
    code: "sgn-it"
  },
  {
    primaryCode: "itl",
    native: "итэнмэн",
    name: "Itelmen",
    secondaryCode: "",
    code: "itl"
  },
  {
    primaryCode: "ipk",
    native: "Iñupiatun",
    name: "Iñupiaq",
    secondaryCode: "",
    code: "ipk"
  },
  {
    primaryCode: "jmk",
    native: "Jamtsk",
    name: "Jamtlandic",
    secondaryCode: "",
    code: "jmk"
  },
  {
    primaryCode: "ja",
    native: "日本語",
    name: "Japanese",
    secondaryCode: "",
    code: "ja"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "jp",
    native: "日本手話",
    name: "Japanese Sign Language",
    code: "sgn-jp"
  },
  {
    primaryCode: "jv",
    native: "Basa Jawa",
    name: "Javanese",
    secondaryCode: "",
    code: "jv"
  },
  {
    primaryCode: "cjy",
    secondaryCode: "hans",
    native: "晋语",
    name: "Jin Chinese [Simplified script]",
    code: "cjy-hans"
  },
  {
    primaryCode: "cjy",
    secondaryCode: "hant",
    native: "晉語",
    name: "Jin Chinese [Traditional script]",
    code: "cjy-hant"
  },
  {
    primaryCode: "kbd",
    native: "Адыгэбзэ",
    name: "Kabardian",
    secondaryCode: "",
    code: "kbd"
  },
  {
    primaryCode: "kab",
    native: "Taqbaylit",
    name: "Kabyle",
    secondaryCode: "",
    code: "kab"
  },
  {
    primaryCode: "mwp",
    native: "Kala Lagaw Ya",
    name: "Kala Lagaw Ya",
    secondaryCode: "",
    code: "mwp"
  },
  {
    primaryCode: "xal",
    native: "Хальмг келн",
    name: "Kalmyk",
    secondaryCode: "",
    code: "xal"
  },
  {
    primaryCode: "kn",
    native: "ಕನ್ನಡ",
    name: "Kannada",
    secondaryCode: "",
    code: "kn"
  },
  {
    primaryCode: "pam",
    native: "Pampangan",
    name: "Kapampangan",
    secondaryCode: "",
    code: "pam"
  },
  {
    primaryCode: "cak",
    native: "Kaqchikel Ch'ab'äl",
    name: "Kaqchikel Mayan",
    secondaryCode: "",
    code: "cak"
  },
  {
    primaryCode: "krc",
    native: "Къарачай-Малкъар тил",
    name: "Karachay-Balkar",
    secondaryCode: "",
    code: "krc"
  },
  {
    primaryCode: "kdr",
    native: "Karaj tili",
    name: "Karaim",
    secondaryCode: "",
    code: "kdr"
  },
  {
    primaryCode: "kaa",
    native: "Qaraqalpaq tili",
    name: "Karakalpak",
    secondaryCode: "",
    code: "kaa"
  },
  {
    primaryCode: "kpt",
    native: "Karata",
    name: "Karata",
    secondaryCode: "",
    code: "kpt"
  },
  {
    primaryCode: "krl",
    native: "Karjala",
    name: "Karelian",
    secondaryCode: "",
    code: "krl"
  },
  {
    primaryCode: "kar",
    native: "Karen",
    name: "Karen",
    secondaryCode: "",
    code: "kar"
  },
  {
    primaryCode: "ks",
    secondaryCode: "arab",
    native: "كشميري",
    name: "Kashmiri [Arabic script]",
    code: "ks-arab"
  },
  {
    primaryCode: "ks",
    secondaryCode: "deva",
    native: "कश्मीरी",
    name: "Kashmiri [Devanagari script]",
    code: "ks-deva"
  },
  {
    primaryCode: "csb",
    native: "Kaszëbsczi",
    name: "Kashubian",
    secondaryCode: "",
    code: "csb"
  },
  {
    primaryCode: "gbb",
    native: "Kaytetye",
    name: "Kaytetye",
    secondaryCode: "",
    code: "gbb"
  },
  {
    primaryCode: "kk",
    native: "қазақша",
    name: "Kazakh",
    secondaryCode: "",
    code: "kk"
  },
  {
    primaryCode: "ket",
    native: "Yenisei Ostyak",
    name: "Ket",
    secondaryCode: "",
    code: "ket"
  },
  {
    primaryCode: "kca",
    native: "хӑнты ясӑӈ",
    name: "Khanty",
    secondaryCode: "",
    code: "kca"
  },
  {
    primaryCode: "kjj",
    native: "каьтш мицI",
    name: "Khinalug",
    secondaryCode: "",
    code: "kjj"
  },
  {
    primaryCode: "km",
    native: "ខ្មែរ",
    name: "Khmer",
    secondaryCode: "",
    code: "km"
  },
  {
    primaryCode: "khi",
    native: "Khoisan",
    name: "Khoisan",
    secondaryCode: "",
    code: "khi"
  },
  {
    primaryCode: "khv",
    native: "Khwarshi",
    name: "Khwarshi",
    secondaryCode: "",
    code: "khv"
  },
  {
    primaryCode: "smi",
    secondaryCode: "smk",
    native: "самь кӣлл",
    name: "Kildin Sami",
    code: "smi-smk"
  },
  {
    primaryCode: "rw",
    native: "Ikinyarwanda",
    name: "Kinyarwanda",
    secondaryCode: "",
    code: "rw"
  },
  {
    primaryCode: "art",
    secondaryCode: "tlh",
    native: "tlhIngan-Hol",
    name: "Klingon",
    code: "art-tlh"
  },
  {
    primaryCode: "tlh",
    native: "tlhIngan-Hol",
    name: "Klingon",
    secondaryCode: "",
    code: "tlh"
  },
  {
    primaryCode: "kv",
    native: "Коми кыв",
    name: "Komi",
    secondaryCode: "",
    code: "kv"
  },
  {
    primaryCode: "kv",
    secondaryCode: "koi",
    native: "Komi-Permyak",
    name: "Komi-Permyak",
    code: "kv-koi"
  },
  {
    primaryCode: "kv",
    secondaryCode: "kpv",
    native: "Komi-Zyrian",
    name: "Komi-Zyrian",
    code: "kv-kpv"
  },
  {
    primaryCode: "kmk",
    native: "ಕಒಂಕಣಇ",
    name: "Konkani",
    secondaryCode: "",
    code: "kmk"
  },
  {
    primaryCode: "ko",
    native: "한국어",
    name: "Korean",
    secondaryCode: "",
    code: "ko"
  },
  {
    primaryCode: "kpy",
    native: "нымылан",
    name: "Koryak",
    secondaryCode: "",
    code: "kpy"
  },
  {
    primaryCode: "koy",
    native: "Denaakkʼe",
    name: "Koyukon",
    secondaryCode: "",
    code: "koy"
  },
  {
    primaryCode: "kry",
    native: "Jek",
    name: "Kryts",
    secondaryCode: "",
    code: "kry"
  },
  {
    primaryCode: "ksk",
    native: "Къумукъ тил",
    name: "Kumyk",
    secondaryCode: "",
    code: "ksk"
  },
  {
    primaryCode: "ku",
    secondaryCode: "arab",
    native: "كوردي",
    name: "Kurdish [Arabic script]",
    code: "ku-arab"
  },
  {
    primaryCode: "ku",
    secondaryCode: "latn",
    native: "Kurmancî",
    name: "Kurdish [Latin script]",
    code: "ku-latn"
  },
  {
    primaryCode: "kgg",
    native: "Kusunda",
    name: "Kusunda",
    secondaryCode: "",
    code: "kgg"
  },
  {
    primaryCode: "kwk",
    native: "Kwak'wala",
    name: "Kwak'wala",
    secondaryCode: "",
    code: "kwk"
  },
  {
    primaryCode: "ky",
    native: "Кыргызча",
    name: "Kyrgyz",
    secondaryCode: "",
    code: "ky"
  },
  {
    primaryCode: "lld",
    native: "ladin",
    name: "Ladin",
    secondaryCode: "",
    code: "lld"
  },
  {
    primaryCode: "lad",
    native: "Djudeo-espanyol",
    name: "Ladino",
    secondaryCode: "",
    code: "lad"
  },
  {
    primaryCode: "lbe",
    native: "лакку маз",
    name: "Lak",
    secondaryCode: "",
    code: "lbe"
  },
  {
    primaryCode: "lkt",
    native: "Lakȟótiyapi",
    name: "Lakota",
    secondaryCode: "",
    code: "lkt"
  },
  {
    primaryCode: "las",
    native: "Lamba",
    name: "Lama",
    secondaryCode: "",
    code: "las"
  },
  {
    primaryCode: "lo",
    native: "ພງສງລງວ",
    name: "Lao",
    secondaryCode: "",
    code: "lo"
  },
  {
    primaryCode: "ltg",
    native: "Latgaļu",
    name: "Latgalian",
    secondaryCode: "",
    code: "ltg"
  },
  {
    primaryCode: "la",
    native: "lingua latīna",
    name: "Latin",
    secondaryCode: "",
    code: "la"
  },
  {
    primaryCode: "lv",
    native: "Latviešu",
    name: "Latvian",
    secondaryCode: "",
    code: "lv"
  },
  {
    primaryCode: "lzz",
    native: "ლაზური",
    name: "Laz",
    secondaryCode: "",
    code: "lzz"
  },
  {
    primaryCode: "lez",
    native: "Лезги чIал",
    name: "Lezgian",
    secondaryCode: "",
    code: "lez"
  },
  {
    primaryCode: "lij",
    native: "lìgure",
    name: "Ligurian",
    secondaryCode: "",
    code: "lij"
  },
  {
    primaryCode: "lim",
    native: "Limburgs",
    name: "Limburgish",
    secondaryCode: "",
    code: "lim"
  },
  {
    primaryCode: "ln",
    native: "Lingála",
    name: "Lingala",
    secondaryCode: "",
    code: "ln"
  },
  {
    primaryCode: "art",
    secondaryCode: "lfn",
    native: "Lingua Franca Nova",
    name: "Lingua Franca Nova",
    code: "art-lfn"
  },
  {
    primaryCode: "lt",
    native: "Lietuvių",
    name: "Lithuanian",
    secondaryCode: "",
    code: "lt"
  },
  {
    primaryCode: "liv",
    native: "Līvõ kēļ",
    name: "Livonian",
    secondaryCode: "",
    code: "liv"
  },
  {
    primaryCode: "olo",
    native: "Olonets",
    name: "Livvi-Karelian",
    secondaryCode: "",
    code: "olo"
  },
  {
    primaryCode: "art",
    secondaryCode: "jbo",
    native: "Lojban",
    name: "Lojban",
    code: "art-jbo"
  },
  {
    primaryCode: "lmo",
    native: "lumbaart",
    name: "Lombard",
    secondaryCode: "",
    code: "lmo"
  },
  {
    primaryCode: "nds",
    native: "Plattdüütsch",
    name: "Low Saxon",
    secondaryCode: "",
    code: "nds"
  },
  {
    primaryCode: "loz",
    native: "Lozi",
    name: "Lozi",
    secondaryCode: "",
    code: "loz"
  },
  {
    primaryCode: "lud",
    native: "lyydin kiel'",
    name: "Ludic",
    secondaryCode: "",
    code: "lud"
  },
  {
    primaryCode: "smi",
    secondaryCode: "smj",
    native: "julevsábme",
    name: "Lule Sami",
    code: "smi-smj"
  },
  {
    primaryCode: "lut",
    native: "dxʷləšucid",
    name: "Lushootseed",
    secondaryCode: "",
    code: "lut"
  },
  {
    primaryCode: "lb",
    native: "Lëtzebuergesch",
    name: "Luxembourgish",
    secondaryCode: "",
    code: "lb"
  },
  {
    primaryCode: "mas",
    native: "ɔl Maa",
    name: "Maasai",
    secondaryCode: "",
    code: "mas"
  },
  {
    primaryCode: "mk",
    native: "Македонски",
    name: "Macedonian",
    secondaryCode: "",
    code: "mk"
  },
  {
    primaryCode: "mdh",
    native: "Maguindanao",
    name: "Maguindanao",
    secondaryCode: "",
    code: "mdh"
  },
  {
    primaryCode: "mkz",
    native: "Makassai",
    name: "Makasae",
    secondaryCode: "",
    code: "mkz"
  },
  {
    primaryCode: "mg",
    native: "Malagasy",
    name: "Malagasy",
    secondaryCode: "",
    code: "mg"
  },
  {
    primaryCode: "ms",
    native: "Bahasa Melayu",
    name: "Malay",
    secondaryCode: "",
    code: "ms"
  },
  {
    primaryCode: "ml",
    native: "മലയാളം",
    name: "Malayalam",
    secondaryCode: "",
    code: "ml"
  },
  {
    primaryCode: "mt",
    native: "Malti",
    name: "Maltese",
    secondaryCode: "",
    code: "mt"
  },
  {
    primaryCode: "mnc",
    native: "Manju gisun",
    name: "Manchu",
    secondaryCode: "",
    code: "mnc"
  },
  {
    primaryCode: "zh",
    secondaryCode: "hans",
    native: "汉语",
    name: "Mandarin Chinese [Simplified script]",
    code: "zh-hans"
  },
  {
    primaryCode: "zh",
    secondaryCode: "hant",
    native: "漢語",
    name: "Mandarin Chinese [Traditional Script]",
    code: "zh-hant"
  },
  {
    primaryCode: "mns",
    native: "Маньси",
    name: "Mansi",
    secondaryCode: "",
    code: "mns"
  },
  {
    primaryCode: "gv",
    native: "Gaelg",
    name: "Manx",
    secondaryCode: "",
    code: "gv"
  },
  {
    primaryCode: "mi",
    native: "Reo Māori",
    name: "Maori",
    secondaryCode: "",
    code: "mi"
  },
  {
    primaryCode: "arn",
    native: "Mapudungun",
    name: "Mapuche",
    secondaryCode: "",
    code: "arn"
  },
  {
    primaryCode: "mr",
    native: "मराठी",
    name: "Marathi",
    secondaryCode: "",
    code: "mr"
  },
  {
    primaryCode: "mrj",
    native: "Кырык мары йӹлмӹ",
    name: "Mari (Hill)",
    secondaryCode: "",
    code: "mrj"
  },
  {
    primaryCode: "mhr",
    native: "Олык марий йылме",
    name: "Mari (Meadow)",
    secondaryCode: "",
    code: "mhr"
  },
  {
    primaryCode: "mh",
    native: "Kajin M̧ajeļ",
    name: "Marshallese",
    secondaryCode: "",
    code: "mh"
  },
  {
    primaryCode: "mfe",
    native: "Morisyen",
    name: "Mauritian",
    secondaryCode: "",
    code: "mfe"
  },
  {
    primaryCode: "es",
    secondaryCode: "mx",
    native: "Español de México",
    name: "Mexican Spanish",
    code: "es-mx"
  },
  {
    primaryCode: "mia",
    native: "Myaamia",
    name: "Miami-Illinois",
    secondaryCode: "",
    code: "mia"
  },
  {
    primaryCode: "mic",
    native: "Míkmaq",
    name: "Micmac",
    secondaryCode: "",
    code: "mic"
  },
  {
    primaryCode: "nl",
    secondaryCode: "mid",
    native: "Middelnederlands",
    name: "Middelnederlands",
    code: "nl-mid"
  },
  {
    primaryCode: "hy",
    secondaryCode: "mid",
    native: "միջին հայերեն",
    name: "Middle Armenian",
    code: "hy-mid"
  },
  {
    primaryCode: "en",
    secondaryCode: "mid",
    native: "Middle English",
    name: "Middle English",
    code: "en-mid"
  },
  {
    primaryCode: "de",
    secondaryCode: "gmh",
    native: "Mittelhochdeutsch",
    name: "Middle High German",
    code: "de-gmh"
  },
  {
    primaryCode: "ko",
    secondaryCode: "mid",
    native: "중세한국어",
    name: "Middle Korean",
    code: "ko-mid"
  },
  {
    primaryCode: "fa",
    secondaryCode: "mid",
    native: "Pārsīk",
    name: "Middle Persian",
    code: "fa-mid"
  },
  {
    primaryCode: "cdo",
    secondaryCode: "hans",
    native: "闽东语",
    name: "Mindong Chinese [Simplified script]",
    code: "cdo-hans"
  },
  {
    primaryCode: "cdo",
    secondaryCode: "hant",
    native: "閩東語",
    name: "Mindong Chinese [Traditional script]",
    code: "cdo-hant"
  },
  {
    primaryCode: "xmf",
    native: "მარგალური ნინა",
    name: "Mingrelian",
    secondaryCode: "",
    code: "xmf"
  },
  {
    primaryCode: "nan",
    secondaryCode: "hans",
    native: "闽南语",
    name: "Minnan Chinese [Simplified script]",
    code: "nan-hans"
  },
  {
    primaryCode: "nan",
    secondaryCode: "hant",
    native: "閩南語",
    name: "Minnan Chinese [Traditional script]",
    code: "nan-hant"
  },
  {
    primaryCode: "mwl",
    native: "Mirandés",
    name: "Mirandese",
    secondaryCode: "",
    code: "mwl"
  },
  {
    primaryCode: "moh",
    native: "Kanien’kéha",
    name: "Mohawk",
    secondaryCode: "",
    code: "moh"
  },
  {
    primaryCode: "mof",
    native: "Moyahikaniw",
    name: "Mohegan",
    secondaryCode: "",
    code: "mof"
  },
  {
    primaryCode: "mdf",
    native: "Мокшень",
    name: "Moksha",
    secondaryCode: "",
    code: "mdf"
  },
  {
    primaryCode: "mo",
    native: "Moldovenească",
    name: "Moldovan",
    secondaryCode: "",
    code: "mo"
  },
  {
    primaryCode: "mnw",
    native: "Mon",
    name: "Mon",
    secondaryCode: "",
    code: "mnw"
  },
  {
    primaryCode: "mn",
    native: "Монгол хэл",
    name: "Mongolian",
    secondaryCode: "",
    code: "mn"
  },
  {
    primaryCode: "fla",
    native: "Séliš",
    name: "Montana Salish",
    secondaryCode: "",
    code: "fla"
  },
  {
    primaryCode: "nah",
    native: "Náhuatl",
    name: "Nahuatl",
    secondaryCode: "",
    code: "nah"
  },
  {
    primaryCode: "na",
    native: "dorerin Naoero",
    name: "Nauruan",
    secondaryCode: "",
    code: "na"
  },
  {
    primaryCode: "nv",
    native: "Diné bizaad",
    name: "Navajo",
    secondaryCode: "",
    code: "nv"
  },
  {
    primaryCode: "nd",
    native: "isiNdebele",
    name: "Ndebele, Northern",
    secondaryCode: "",
    code: "nd"
  },
  {
    primaryCode: "nr",
    native: "Nrebele",
    name: "Ndebele, Southern",
    secondaryCode: "",
    code: "nr"
  },
  {
    primaryCode: "nap",
    native: "Napulitano",
    name: "Neapolitan",
    secondaryCode: "",
    code: "nap"
  },
  {
    primaryCode: "yrk",
    native: 'Ненэця" вада',
    name: "Nenets",
    secondaryCode: "",
    code: "yrk"
  },
  {
    primaryCode: "aii",
    native: "Neo-Aramaic",
    name: "Neo-Aramaic",
    secondaryCode: "",
    code: "aii"
  },
  {
    primaryCode: "new",
    native: "नेपाल भाषा",
    name: "Nepal Bhasa",
    secondaryCode: "",
    code: "new"
  },
  {
    primaryCode: "ne",
    native: "नेपाली",
    name: "Nepali",
    secondaryCode: "",
    code: "ne"
  },
  {
    primaryCode: "en",
    secondaryCode: "nz",
    native: "New Zealand English",
    name: "New Zealand English",
    code: "en-nz"
  },
  {
    primaryCode: "ntj",
    native: "Ngaanyatjarra",
    name: "Ngaanyatjarra",
    secondaryCode: "",
    code: "ntj"
  },
  {
    primaryCode: "nio",
    native: "Ня’’ сиәде",
    name: "Nganasan",
    secondaryCode: "",
    code: "nio"
  },
  {
    primaryCode: "es",
    secondaryCode: "ni",
    native: "Español de Nicaragua",
    name: "Nicaraguan Spanish",
    code: "es-ni"
  },
  {
    primaryCode: "nll",
    native: "Nahali",
    name: "Nihali",
    secondaryCode: "",
    code: "nll"
  },
  {
    primaryCode: "niu",
    native: "ko e vagahau Niuē",
    name: "Niuean",
    secondaryCode: "",
    code: "niu"
  },
  {
    primaryCode: "niv",
    native: "Нивхгу диф",
    name: "Nivkh",
    secondaryCode: "",
    code: "niv"
  },
  {
    primaryCode: "nog",
    native: "Ногай тили",
    name: "Nogai",
    secondaryCode: "",
    code: "nog"
  },
  {
    primaryCode: "pih",
    native: "Norfuk/Pitkern",
    name: "Norfuk/Pitkern",
    secondaryCode: "",
    code: "pih"
  },
  {
    primaryCode: "frr",
    native: "Nordfriisk",
    name: "North Frisian",
    secondaryCode: "",
    code: "frr"
  },
  {
    primaryCode: "smi",
    secondaryCode: "sme",
    native: "davvisámegiella",
    name: "Northern Sami",
    code: "smi-sme"
  },
  {
    primaryCode: "no",
    native: "Norsk",
    name: "Norwegian",
    secondaryCode: "",
    code: "no"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "no",
    native: "NSL",
    name: "Norwegian Sign Language",
    code: "sgn-no"
  },
  {
    primaryCode: "no",
    secondaryCode: "nb",
    native: "Bokmål",
    name: "Norwegian, Bokmål",
    code: "no-nb"
  },
  {
    primaryCode: "no",
    secondaryCode: "nn",
    native: "Nynorsk",
    name: "Norwegian, Nynorsk",
    code: "no-nn"
  },
  {
    primaryCode: "no",
    secondaryCode: "val",
    native: "Vallemål",
    name: "Norwegian, Vallemål",
    code: "no-val"
  },
  {
    primaryCode: "art",
    secondaryCode: "nov",
    native: "Novial",
    name: "Novial",
    code: "art-nov"
  },
  {
    primaryCode: "blc",
    native: "Bella Coola",
    name: "Nuxálk",
    secondaryCode: "",
    code: "blc"
  },
  {
    primaryCode: "oc",
    native: "Occitan",
    name: "Occitan",
    secondaryCode: "",
    code: "oc"
  },
  {
    primaryCode: "oj",
    native: "ᐊᓂᔑᓈᐯ",
    name: "Ojibwe",
    secondaryCode: "",
    code: "oj"
  },
  {
    primaryCode: "ryu",
    native: "ウチナーグチ",
    name: "Okinawan",
    secondaryCode: "",
    code: "ryu"
  },
  {
    primaryCode: "cu",
    native: "Ѩзыкъ словѣньскъ",
    name: "Old Church Slavonic",
    secondaryCode: "",
    code: "cu"
  },
  {
    primaryCode: "en",
    secondaryCode: "old",
    native: "Ænglisc",
    name: "Old English",
    code: "en-old"
  },
  {
    primaryCode: "fr",
    secondaryCode: "old",
    native: "Ancien français",
    name: "Old French",
    code: "fr-old"
  },
  {
    primaryCode: "ofs",
    native: "Aldfrysk",
    name: "Old Frisian",
    secondaryCode: "",
    code: "ofs"
  },
  {
    primaryCode: "ka",
    secondaryCode: "old",
    native: "ენაჲ ქართული",
    name: "Old Georgian",
    code: "ka-old"
  },
  {
    primaryCode: "de",
    secondaryCode: "goh",
    native: "Althochdeutsch",
    name: "Old High German",
    code: "de-goh"
  },
  {
    primaryCode: "sga",
    native: "Goídelc",
    name: "Old Irish",
    secondaryCode: "",
    code: "sga"
  },
  {
    primaryCode: "non",
    native: "Norrœnt",
    name: "Old Norse",
    secondaryCode: "",
    code: "non"
  },
  {
    primaryCode: "fa",
    secondaryCode: "old",
    native: "*Pārsīka",
    name: "Old Persian",
    code: "fa-old"
  },
  {
    primaryCode: "de",
    secondaryCode: "osx",
    native: "Altsächsisch",
    name: "Old Saxon",
    code: "de-osx"
  },
  {
    primaryCode: "es",
    secondaryCode: "old",
    native: "Castellano antiguo",
    name: "Old Spanish",
    code: "es-old"
  },
  {
    primaryCode: "udi",
    secondaryCode: "old",
    native: "Old Udi",
    name: "Old Udi",
    code: "udi-old"
  },
  {
    primaryCode: "one",
    native: "Onʌyotaʔa:ka",
    name: "Oneida",
    secondaryCode: "",
    code: "one"
  },
  {
    primaryCode: "or",
    native: "ଓଡ଼ିଆ",
    name: "Oriya",
    secondaryCode: "",
    code: "or"
  },
  {
    primaryCode: "om",
    native: "Oromoo",
    name: "Oromoo",
    secondaryCode: "",
    code: "om"
  },
  {
    primaryCode: "os",
    secondaryCode: "digor",
    native: "дигорон",
    name: "Ossetic, Digor",
    code: "os-digor"
  },
  {
    primaryCode: "os",
    native: "Ирон",
    name: "Ossetic, Iron",
    secondaryCode: "",
    code: "os"
  },
  {
    primaryCode: "ota",
    native: "عثمانلیجہ",
    name: "Ottoman Turkish",
    secondaryCode: "",
    code: "ota"
  },
  {
    primaryCode: "ood",
    native: "Oʼodham ñiok",
    name: "O’odham",
    secondaryCode: "",
    code: "ood"
  },
  {
    primaryCode: "pau",
    native: "Palauan",
    name: "Palauan",
    secondaryCode: "",
    code: "pau"
  },
  {
    primaryCode: "pi",
    native: "पाळि",
    name: "Pali",
    secondaryCode: "",
    code: "pi"
  },
  {
    primaryCode: "es",
    secondaryCode: "pa",
    native: "Español de Panamá",
    name: "Panamanian Spanish",
    code: "es-pa"
  },
  {
    primaryCode: "rue",
    secondaryCode: "rs",
    native: "Бачваньски руски язик",
    name: "Pannonian Rusyn",
    code: "rue-rs"
  },
  {
    primaryCode: "pap",
    native: "Papiamentu",
    name: "Papiamento",
    secondaryCode: "",
    code: "pap"
  },
  {
    primaryCode: "paa",
    native: "Papuan",
    name: "Papuan",
    secondaryCode: "",
    code: "paa"
  },
  {
    primaryCode: "es",
    secondaryCode: "py",
    native: "Español de Paraguay",
    name: "Paraguayan Spanish",
    code: "es-py"
  },
  {
    primaryCode: "ps",
    native: "پښتو",
    name: "Pashto",
    secondaryCode: "",
    code: "ps"
  },
  {
    primaryCode: "fa",
    native: "فارسی",
    name: "Persian",
    secondaryCode: "",
    code: "fa"
  },
  {
    primaryCode: "es",
    secondaryCode: "pe",
    native: "Español de Perú",
    name: "Peruvian Spanish",
    code: "es-pe"
  },
  {
    primaryCode: "phn",
    native: "Phoenician",
    name: "Phoenician",
    secondaryCode: "",
    code: "phn"
  },
  {
    primaryCode: "pms",
    native: "piemontèis",
    name: "Piedmontese",
    secondaryCode: "",
    code: "pms"
  },
  {
    primaryCode: "piu",
    native: "Pintupi-Luritja",
    name: "Pintupi-Luritja",
    secondaryCode: "",
    code: "piu"
  },
  {
    primaryCode: "ppl",
    native: "Nawat",
    name: "Pipil",
    secondaryCode: "",
    code: "ppl"
  },
  {
    primaryCode: "myp",
    native: "xapaitíiso",
    name: "Pirahã",
    secondaryCode: "",
    code: "myp"
  },
  {
    primaryCode: "smi",
    secondaryCode: "smp",
    native: "biđonsámegiella",
    name: "Pite Sami",
    code: "smi-smp"
  },
  {
    primaryCode: "pjt",
    native: "Pitjantjatjara",
    name: "Pitjantjatjara",
    secondaryCode: "",
    code: "pjt"
  },
  {
    primaryCode: "pdt",
    native: "Plautdietsch",
    name: "Plautdietsch",
    secondaryCode: "",
    code: "pdt"
  },
  {
    primaryCode: "pl",
    native: "Polski",
    name: "Polish",
    secondaryCode: "",
    code: "pl"
  },
  {
    primaryCode: "pt",
    native: "Português",
    name: "Portuguese",
    secondaryCode: "",
    code: "pt"
  },
  {
    primaryCode: "prg",
    native: "Prūsiskan",
    name: "Prussian",
    secondaryCode: "",
    code: "prg"
  },
  {
    primaryCode: "es",
    secondaryCode: "pr",
    native: "Español de Puerto Rico",
    name: "Puerto Rican Spanish",
    code: "es-pr"
  },
  {
    primaryCode: "pa",
    secondaryCode: "arab",
    native: "پنجابي",
    name: "Punjabi [Arabic script]",
    code: "pa-arab"
  },
  {
    primaryCode: "pa",
    secondaryCode: "deva",
    native: "पंजाबी",
    name: "Punjabi [Devanagari script]",
    code: "pa-deva"
  },
  {
    primaryCode: "pa",
    secondaryCode: "guru",
    native: "ਪੰਜਾਬੀ",
    name: "Punjabi [Gurmukhi script]",
    code: "pa-guru"
  },
  {
    primaryCode: "fr",
    secondaryCode: "qc",
    native: "Québécois",
    name: "Quebec French",
    code: "fr-qc"
  },
  {
    primaryCode: "qu",
    native: "Runa simi",
    name: "Quechua",
    secondaryCode: "",
    code: "qu"
  },
  {
    primaryCode: "art",
    secondaryCode: "qya",
    native: "Quenya",
    name: "Quenya",
    code: "art-qya"
  },
  {
    primaryCode: "rap",
    native: "Rapa Nui",
    name: "Rapa Nui",
    secondaryCode: "",
    code: "rap"
  },
  {
    primaryCode: "rgn",
    native: "Romagnòl",
    name: "Romagnol",
    secondaryCode: "",
    code: "rgn"
  },
  {
    primaryCode: "ro",
    native: "Română",
    name: "Romanian",
    secondaryCode: "",
    code: "ro"
  },
  {
    primaryCode: "rm",
    native: "Rumantsch",
    name: "Romansh",
    secondaryCode: "",
    code: "rm"
  },
  {
    primaryCode: "rom",
    secondaryCode: "cyrl",
    native: "Романи",
    name: "Romany [Cyrillic script]",
    code: "rom-cyrl"
  },
  {
    primaryCode: "rom",
    secondaryCode: "latn",
    native: "Romani",
    name: "Romany [Latin script]",
    code: "rom-latn"
  },
  {
    primaryCode: "roo",
    native: "Rotokas",
    name: "Rotokas",
    secondaryCode: "",
    code: "roo"
  },
  {
    primaryCode: "rtm",
    native: "Fäeag Rotuma",
    name: "Rotuman",
    secondaryCode: "",
    code: "rtm"
  },
  {
    primaryCode: "ru",
    native: "Русский",
    name: "Russian",
    secondaryCode: "",
    code: "ru"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "ru",
    native: "РЖЯ",
    name: "Russian Sign Language",
    code: "sgn-ru"
  },
  {
    primaryCode: "rue",
    native: "Rusyn",
    name: "Rusyn",
    secondaryCode: "",
    code: "rue"
  },
  {
    primaryCode: "rut",
    native: "мыхIабишды чIел",
    name: "Rutul",
    secondaryCode: "",
    code: "rut"
  },
  {
    primaryCode: "es",
    secondaryCode: "sv",
    native: "Español de El Salvador",
    name: "Salvadoran Spanish",
    code: "es-sv"
  },
  {
    primaryCode: "smi",
    native: "Sámi",
    name: "Sami",
    secondaryCode: "",
    code: "smi"
  },
  {
    primaryCode: "sm",
    native: "le gagana Samoa",
    name: "Samoan",
    secondaryCode: "",
    code: "sm"
  },
  {
    primaryCode: "sgs",
    native: "Žemaitėška",
    name: "Samogitian",
    secondaryCode: "",
    code: "sgs"
  },
  {
    primaryCode: "sg",
    native: "Sängö",
    name: "Sango",
    secondaryCode: "",
    code: "sg"
  },
  {
    primaryCode: "sa",
    native: "संस्कृत",
    name: "Sanskrit",
    secondaryCode: "",
    code: "sa"
  },
  {
    primaryCode: "sc",
    native: "Sardu",
    name: "Sardinian",
    secondaryCode: "",
    code: "sc"
  },
  {
    primaryCode: "stq",
    native: "Seeltersk",
    name: "Saterland Frisian",
    secondaryCode: "",
    code: "stq"
  },
  {
    primaryCode: "sco",
    native: "Scoats",
    name: "Scots",
    secondaryCode: "",
    code: "sco"
  },
  {
    primaryCode: "gd",
    native: "Gàidhlig",
    name: "Scottish Gaelic",
    secondaryCode: "",
    code: "gd"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "rs",
    native: "Српски знаковни језик",
    name: "Serbian Sign Language",
    code: "sgn-rs"
  },
  {
    primaryCode: "sr",
    secondaryCode: "cyrl",
    native: "Српски",
    name: "Serbian [Cyrillic script]",
    code: "sr-cyrl"
  },
  {
    primaryCode: "sr",
    secondaryCode: "latn",
    native: "Srpski",
    name: "Serbian [Latin script]",
    code: "sr-latn"
  },
  {
    primaryCode: "sh",
    native: "srpskohrvatski",
    name: "Serbo-Croatian",
    secondaryCode: "",
    code: "sh"
  },
  {
    primaryCode: "crs",
    native: "Seselwa",
    name: "Seychellois Creole",
    secondaryCode: "",
    code: "crs"
  },
  {
    primaryCode: "shn",
    native: "Shan",
    name: "Shan",
    secondaryCode: "",
    code: "shn"
  },
  {
    primaryCode: "sn",
    native: "chiShona",
    name: "Shona",
    secondaryCode: "",
    code: "sn"
  },
  {
    primaryCode: "shh",
    native: "Sosoni’da̲i̲gwape",
    name: "Shoshoni",
    secondaryCode: "",
    code: "shh"
  },
  {
    primaryCode: "shs",
    native: "Secwepemctsín",
    name: "Shuswap",
    secondaryCode: "",
    code: "shs"
  },
  {
    primaryCode: "scn",
    native: "Sicilianu",
    name: "Sicilian",
    secondaryCode: "",
    code: "scn"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "ca-qc",
    native: "LSQ",
    name: "Sign language",
    code: "sgn-ca-qc"
  },
  {
    primaryCode: "sgn",
    native: "Sign language",
    name: "Sign language",
    secondaryCode: "",
    code: "sgn"
  },
  {
    primaryCode: "szl",
    native: "Ślůnski",
    name: "Silesian",
    secondaryCode: "",
    code: "szl"
  },
  {
    primaryCode: "sml",
    native: "Sinama, Central",
    name: "Sinama, Central",
    secondaryCode: "",
    code: "sml"
  },
  {
    primaryCode: "art",
    secondaryCode: "sjn",
    native: "Sindarin",
    name: "Sindarin",
    code: "art-sjn"
  },
  {
    primaryCode: "sd",
    secondaryCode: "arab",
    native: "سنڗي",
    name: "Sindhi [Arabic script]",
    code: "sd-arab"
  },
  {
    primaryCode: "sd",
    secondaryCode: "deva",
    native: "सनिध",
    name: "Sindhi [Devanagari script]",
    code: "sd-deva"
  },
  {
    primaryCode: "en",
    secondaryCode: "sg",
    native: "Singapore English",
    name: "Singapore English",
    code: "en-sg"
  },
  {
    primaryCode: "si",
    native: "සිංහල",
    name: "Sinhalese",
    secondaryCode: "",
    code: "si"
  },
  {
    primaryCode: "smi",
    secondaryCode: "sms",
    native: "sääˊmǩiõll",
    name: "Skolt Sami",
    code: "smi-sms"
  },
  {
    primaryCode: "den",
    native: "Slavey",
    name: "Slavey",
    secondaryCode: "",
    code: "den"
  },
  {
    primaryCode: "sk",
    native: "Slovenčina",
    name: "Slovak",
    secondaryCode: "",
    code: "sk"
  },
  {
    primaryCode: "sl",
    native: "Slovenščina",
    name: "Slovene",
    secondaryCode: "",
    code: "sl"
  },
  {
    primaryCode: "sog",
    native: "Sogdian",
    name: "Sogdian",
    secondaryCode: "",
    code: "sog"
  },
  {
    primaryCode: "art",
    secondaryCode: "srs",
    native: "Solresol",
    name: "Solresol",
    code: "art-srs"
  },
  {
    primaryCode: "so",
    native: "Soomaali",
    name: "Somali",
    secondaryCode: "",
    code: "so"
  },
  {
    primaryCode: "ckb",
    native: "سۆرانی",
    name: "Soranî",
    secondaryCode: "",
    code: "ckb"
  },
  {
    primaryCode: "dsb",
    native: "Dolnoserbšćina",
    name: "Sorbian (lower)",
    secondaryCode: "",
    code: "dsb"
  },
  {
    primaryCode: "hsb",
    native: "Hornjoserbšćina",
    name: "Sorbian (upper)",
    secondaryCode: "",
    code: "hsb"
  },
  {
    primaryCode: "st",
    native: "seSotho",
    name: "Sotho",
    secondaryCode: "",
    code: "st"
  },
  {
    primaryCode: "smi",
    secondaryCode: "sma",
    native: "åarjelsaemien gïele",
    name: "Southern Sami",
    code: "smi-sma"
  },
  {
    primaryCode: "es",
    native: "Español",
    name: "Spanish",
    secondaryCode: "",
    code: "es"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "es",
    native: "LSE",
    name: "Spanish Sign Language",
    code: "sgn-es"
  },
  {
    primaryCode: "es",
    secondaryCode: "es",
    native: "Español de España",
    name: "Spanish, Spain",
    code: "es-es"
  },
  {
    primaryCode: "srn",
    native: "Sranantogo",
    name: "Sranan Tongo",
    secondaryCode: "",
    code: "srn"
  },
  {
    primaryCode: "sux",
    native: "eme-ĝir",
    name: "Sumerian",
    secondaryCode: "",
    code: "sux"
  },
  {
    primaryCode: "su",
    native: "Bahasa Sunda",
    name: "Sundanese",
    secondaryCode: "",
    code: "su"
  },
  {
    primaryCode: "sva",
    native: "ლუშნუ ნინ",
    name: "Svan",
    secondaryCode: "",
    code: "sva"
  },
  {
    primaryCode: "sw",
    native: "Kiswahili",
    name: "Swahili",
    secondaryCode: "",
    code: "sw"
  },
  {
    primaryCode: "ss",
    native: "siSwati",
    name: "Swati",
    secondaryCode: "",
    code: "ss"
  },
  {
    primaryCode: "sv",
    native: "Svenska",
    name: "Swedish",
    secondaryCode: "",
    code: "sv"
  },
  {
    primaryCode: "sgn",
    secondaryCode: "se",
    native: "TSP",
    name: "Swedish Sign Language",
    code: "sgn-se"
  },
  {
    primaryCode: "fr",
    secondaryCode: "ch",
    native: "Français de la Suisse",
    name: "Swiss French",
    code: "fr-ch"
  },
  {
    primaryCode: "de",
    secondaryCode: "gsw",
    native: "Schwyzerdütsch",
    name: "Swiss German",
    code: "de-gsw"
  },
  {
    primaryCode: "de",
    secondaryCode: "ch",
    native: "Schweizer Hochdeutsch",
    name: "Swiss Standard German",
    code: "de-ch"
  },
  {
    primaryCode: "syc",
    native: "ܣܘܪܝܝܐ",
    name: "Syriac",
    secondaryCode: "",
    code: "syc"
  },
  {
    primaryCode: "tab",
    native: "табасаран чIал",
    name: "Tabasaran",
    secondaryCode: "",
    code: "tab"
  },
  {
    primaryCode: "tl",
    native: "Tagalog",
    name: "Tagalog",
    secondaryCode: "",
    code: "tl"
  },
  {
    primaryCode: "ty",
    native: "Reo Mā'ohi",
    name: "Tahitian",
    secondaryCode: "",
    code: "ty"
  },
  {
    primaryCode: "fa",
    secondaryCode: "tj",
    native: "тоҷикӣ",
    name: "Tajik",
    code: "fa-tj"
  },
  {
    primaryCode: "tly",
    native: "تالشی زَوُن",
    name: "Talysh",
    secondaryCode: "",
    code: "tly"
  },
  {
    primaryCode: "taq",
    native: "Tamasheq",
    name: "Tamasheq",
    secondaryCode: "",
    code: "taq"
  },
  {
    primaryCode: "ta",
    native: "தமிழ்",
    name: "Tamil",
    secondaryCode: "",
    code: "ta"
  },
  {
    primaryCode: "ta",
    secondaryCode: "lk",
    native: "தமிழ் (இலங்கை)",
    name: "Tamil, Sri Lankan",
    code: "ta-lk"
  },
  {
    primaryCode: "scn",
    secondaryCode: "tara",
    native: "Tarandíne",
    name: "Tarantino",
    code: "scn-tara"
  },
  {
    primaryCode: "ttt",
    native: "Tati",
    name: "Tat",
    secondaryCode: "",
    code: "ttt"
  },
  {
    primaryCode: "tt",
    native: "Татарча",
    name: "Tatar",
    secondaryCode: "",
    code: "tt"
  },
  {
    primaryCode: "tsg",
    native: "Bahasa Sūg",
    name: "Tausug",
    secondaryCode: "",
    code: "tsg"
  },
  {
    primaryCode: "te",
    native: "తెలుగు",
    name: "Telugu",
    secondaryCode: "",
    code: "te"
  },
  {
    primaryCode: "smi",
    secondaryCode: "smt",
    native: "saa´mekiill",
    name: "Ter Sami",
    code: "smi-smt"
  },
  {
    primaryCode: "tet",
    native: "Tetun",
    name: "Tetum",
    secondaryCode: "",
    code: "tet"
  },
  {
    primaryCode: "th",
    native: "ภาษาไทย",
    name: "Thai",
    secondaryCode: "",
    code: "th"
  },
  {
    primaryCode: "bo",
    native: "བོད་སྐད་",
    name: "Tibetan",
    secondaryCode: "",
    code: "bo"
  },
  {
    primaryCode: "ti",
    native: "ትግርኛ",
    name: "Tigrinya",
    secondaryCode: "",
    code: "ti"
  },
  {
    primaryCode: "tin",
    native: "Tindi",
    name: "Tindi",
    secondaryCode: "",
    code: "tin"
  },
  {
    primaryCode: "tiw",
    native: "Tiwi",
    name: "Tiwi",
    secondaryCode: "",
    code: "tiw"
  },
  {
    primaryCode: "tli",
    native: "Lingít",
    name: "Tlingit",
    secondaryCode: "",
    code: "tli"
  },
  {
    primaryCode: "tpi",
    native: "Tok Pisin",
    name: "Tok Pisin",
    secondaryCode: "",
    code: "tpi"
  },
  {
    primaryCode: "art",
    secondaryCode: "tkp",
    native: "Toki Pona",
    name: "Toki Pona",
    code: "art-tkp"
  },
  {
    primaryCode: "to",
    native: "lea faka-Tonga",
    name: "Tongan",
    secondaryCode: "",
    code: "to"
  },
  {
    primaryCode: "tkr",
    native: "цӀаӀхна миз",
    name: "Tsakhur",
    secondaryCode: "",
    code: "tkr"
  },
  {
    primaryCode: "ddo",
    native: "Цезйас мец",
    name: "Tsez",
    secondaryCode: "",
    code: "ddo"
  },
  {
    primaryCode: "ts",
    native: "xiTsonga",
    name: "Tsonga",
    secondaryCode: "",
    code: "ts"
  },
  {
    primaryCode: "tn",
    native: "seTswana",
    name: "Tswana",
    secondaryCode: "",
    code: "tn"
  },
  {
    primaryCode: "tr",
    native: "Türkçe",
    name: "Turkish",
    secondaryCode: "",
    code: "tr"
  },
  {
    primaryCode: "tk",
    native: "Türkmençe",
    name: "Turkmen",
    secondaryCode: "",
    code: "tk"
  },
  {
    primaryCode: "tyv",
    native: "Тыва дыл",
    name: "Tuvan",
    secondaryCode: "",
    code: "tyv"
  },
  {
    primaryCode: "twi",
    native: "Twi",
    name: "Twi",
    secondaryCode: "",
    code: "twi"
  },
  {
    primaryCode: "uby",
    native: "tʷaχəbza",
    name: "Ubykh",
    secondaryCode: "",
    code: "uby"
  },
  {
    primaryCode: "udi",
    native: "удин муз",
    name: "Udi",
    secondaryCode: "",
    code: "udi"
  },
  {
    primaryCode: "udm",
    native: "Удмурт кыл",
    name: "Udmurt",
    secondaryCode: "",
    code: "udm"
  },
  {
    primaryCode: "uga",
    native: "Ugaritic",
    name: "Ugaritic",
    secondaryCode: "",
    code: "uga"
  },
  {
    primaryCode: "uk",
    native: "Українська",
    name: "Ukrainian",
    secondaryCode: "",
    code: "uk"
  },
  {
    primaryCode: "xum",
    native: "Iuku Umbriu",
    name: "Umbrian",
    secondaryCode: "",
    code: "xum"
  },
  {
    primaryCode: "smi",
    secondaryCode: "smu",
    native: "ubmisámegiella",
    name: "Ume Sami",
    code: "smi-smu"
  },
  {
    primaryCode: "ur",
    native: "اُردو",
    name: "Urdu",
    secondaryCode: "",
    code: "ur"
  },
  {
    primaryCode: "es",
    secondaryCode: "uy",
    native: "Español de Uruguay",
    name: "Uruguayan Spanish",
    code: "es-uy"
  },
  {
    primaryCode: "ug",
    native: "ﺋۇيغۇر",
    name: "Uyghur",
    secondaryCode: "",
    code: "ug"
  },
  {
    primaryCode: "uz",
    native: "O'zbekcha",
    name: "Uzbek",
    secondaryCode: "",
    code: "uz"
  },
  {
    primaryCode: "vai",
    native: "Vai",
    name: "Vai",
    secondaryCode: "",
    code: "vai"
  },
  {
    primaryCode: "ve",
    native: "tshiVenda",
    name: "Venda",
    secondaryCode: "",
    code: "ve"
  },
  {
    primaryCode: "vec",
    native: "vèneto",
    name: "Venetian",
    secondaryCode: "",
    code: "vec"
  },
  {
    primaryCode: "es",
    secondaryCode: "ve",
    native: "Español de Venezuela",
    name: "Venezuelan Spanish",
    code: "es-ve"
  },
  {
    primaryCode: "vep",
    native: "Vepsän kel'",
    name: "Veps",
    secondaryCode: "",
    code: "vep"
  },
  {
    primaryCode: "vi",
    native: "Tiếng Việt",
    name: "Vietnamese",
    secondaryCode: "",
    code: "vi"
  },
  {
    primaryCode: "art",
    secondaryCode: "vo",
    native: "Volapük",
    name: "Volapuk",
    code: "art-vo"
  },
  {
    primaryCode: "vro",
    native: "Võro kiil",
    name: "Voro",
    secondaryCode: "",
    code: "vro"
  },
  {
    primaryCode: "vot",
    native: "vađđa ceeli",
    name: "Votic",
    secondaryCode: "",
    code: "vot"
  },
  {
    primaryCode: "prk",
    native: "Parauk",
    name: "Wa",
    secondaryCode: "",
    code: "prk"
  },
  {
    primaryCode: "wls",
    native: "Fakaʻuvea",
    name: "Wallisian",
    secondaryCode: "",
    code: "wls"
  },
  {
    primaryCode: "wa",
    native: "Walon",
    name: "Walloon",
    secondaryCode: "",
    code: "wa"
  },
  {
    primaryCode: "war",
    native: "Winaray",
    name: "Waray-Waray",
    secondaryCode: "",
    code: "war"
  },
  {
    primaryCode: "wbp",
    native: "Warlpiri",
    name: "Warlpiri",
    secondaryCode: "",
    code: "wbp"
  },
  {
    primaryCode: "wrm",
    native: "Warumungu",
    name: "Warumungu",
    secondaryCode: "",
    code: "wrm"
  },
  {
    primaryCode: "wac",
    native: "Wasco-Wishram",
    name: "Wasco-Wishram",
    secondaryCode: "",
    code: "wac"
  },
  {
    primaryCode: "was",
    native: "Washo",
    name: "Washo",
    secondaryCode: "",
    code: "was"
  },
  {
    primaryCode: "cy",
    native: "Cymraeg",
    name: "Welsh",
    secondaryCode: "",
    code: "cy"
  },
  {
    primaryCode: "fy",
    native: "Frysk",
    name: "West Frisian",
    secondaryCode: "",
    code: "fy"
  },
  {
    primaryCode: "pnb",
    native: "پنجابی",
    name: "Western Panjabi",
    secondaryCode: "",
    code: "pnb"
  },
  {
    primaryCode: "wo",
    native: "Wolof",
    name: "Wolof",
    secondaryCode: "",
    code: "wo"
  },
  {
    primaryCode: "wuu",
    secondaryCode: "hans",
    native: "吴语",
    name: "Wu Chinese [Simplified script]",
    code: "wuu-hans"
  },
  {
    primaryCode: "wuu",
    secondaryCode: "hant",
    native: "吳語",
    name: "Wu Chinese [Traditional script]",
    code: "wuu-hant"
  },
  {
    primaryCode: "xh",
    native: "isiXhosa",
    name: "Xhosa",
    secondaryCode: "",
    code: "xh"
  },
  {
    primaryCode: "hsn",
    secondaryCode: "hans",
    native: "湘语",
    name: "Xiang Chinese [Simplified script]",
    code: "hsn-hans"
  },
  {
    primaryCode: "hsn",
    secondaryCode: "hant",
    native: "湘語",
    name: "Xiang Chinese [Traditional script]",
    code: "hsn-hant"
  },
  {
    primaryCode: "sah",
    native: "Саха тыла",
    name: "Yakut",
    secondaryCode: "",
    code: "sah"
  },
  {
    primaryCode: "ii",
    native: "ꆇꉙ",
    name: "Yi",
    secondaryCode: "",
    code: "ii"
  },
  {
    primaryCode: "yi",
    native: "ייִדיש",
    name: "Yiddish",
    secondaryCode: "",
    code: "yi"
  },
  {
    primaryCode: "yol",
    native: "Yola",
    name: "Yola",
    secondaryCode: "",
    code: "yol"
  },
  {
    primaryCode: "yo",
    native: "Yorùbá",
    name: "Yoruba",
    secondaryCode: "",
    code: "yo"
  },
  {
    primaryCode: "yua",
    native: "Maaya t'aan",
    name: "Yucatec Maya",
    secondaryCode: "",
    code: "yua"
  },
  {
    primaryCode: "esu",
    native: "Yup’ik",
    name: "Yup’ik",
    secondaryCode: "",
    code: "esu"
  },
  {
    primaryCode: "zap",
    native: "Diidzaj",
    name: "Zapotec",
    secondaryCode: "",
    code: "zap"
  },
  {
    primaryCode: "zza",
    native: "Zazaki",
    name: "Zazaki",
    secondaryCode: "",
    code: "zza"
  },
  {
    primaryCode: "zea",
    native: "Zeêuws",
    name: "Zeelandic",
    secondaryCode: "",
    code: "zea"
  },
  {
    primaryCode: "za",
    native: "Saw cuəŋ",
    name: "Zhuang",
    secondaryCode: "",
    code: "za"
  },
  {
    primaryCode: "zu",
    native: "isiZulu",
    name: "Zulu",
    secondaryCode: "",
    code: "zu"
  },
  {
    primaryCode: "zun",
    native: "Zuni",
    name: "Zuni",
    secondaryCode: "",
    code: "zun"
  }
];

export const TRANSLATIONS = [
  {
    code: "en",
    name: "English",
    emoji: "🇺🇸",
    native: ""
  },
  {
    code: "af",
    name: "Afrikaans",
    emoji: "🇿🇦",
    native: ""
  },
  {
    code: "sq",
    name: "Albanian",
    emoji: "🇦🇱",
    native: "Shqipe"
  },
  {
    code: "am",
    name: "Amharic",
    emoji: "🇪🇹",
    native: "አማርኛ"
  },
  {
    code: "ar",
    name: "Arabic",
    emoji: "🇸🇦",
    native: "العربية"
  },
  {
    code: "hy",
    name: "Armenian",
    emoji: "🇦🇲",
    native: "Հայերեն"
  },
  {
    code: "az",
    name: "Azerbaijani",
    emoji: "🇦🇿",
    native: "Azərbaycanca"
  },
  {
    code: "eu",
    name: "Basque",
    emoji: "🇪🇺",
    native: "Euskara"
  },
  {
    code: "be",
    name: "Belarusian",
    emoji: "🇧🇾",
    native: "Беларускі"
  },
  {
    code: "bn",
    name: "Bengali",
    emoji: "🇧🇩",
    native: "বাংলা"
  },
  {
    code: "bs",
    name: "Bosnian",
    emoji: "🇧🇦",
    native: "Bosanski"
  },
  {
    code: "bg",
    name: "Bulgarian",
    emoji: "🇧🇬",
    native: "Български"
  },
  {
    code: "ca",
    name: "Catalan",
    emoji: "🇪🇸",
    native: "Català"
  },
  {
    code: "ceb",
    name: "Cebuano",
    emoji: "🇵🇭",
    native: ""
  },
  {
    code: "ny",
    name: "Chichewa",
    emoji: "🇲🇼",
    native: "Nyanja"
  },
  {
    code: "zh",
    name: "Chinese (Simplified)",
    emoji: "🇨🇳",
    native: "汉语"
  },
  {
    code: "zh-TW",
    name: "Chinese (Traditional)",
    emoji: "🇹🇼",
    native: ""
  },
  {
    code: "co",
    name: "Corsican",
    emoji: "🇫🇷",
    native: "Corsu"
  },
  {
    code: "hr",
    name: "Croatian",
    emoji: "🇭🇷",
    native: "Hrvatski"
  },
  {
    code: "cs",
    name: "Czech",
    emoji: "🇨🇿",
    native: "Čeština"
  },
  {
    code: "da",
    name: "Danish",
    emoji: "🇩🇰",
    native: "Dansk"
  },
  {
    code: "nl",
    name: "Dutch",
    emoji: "🇳🇱",
    native: "Nederlands"
  },
  {
    code: "eo",
    name: "Esperanto",
    emoji: "🌍",
    native: ""
  },
  {
    code: "et",
    name: "Estonian",
    emoji: "🇪🇪",
    native: "Eesti"
  },
  {
    code: "tl",
    name: "Filipino",
    emoji: "🇵🇭",
    native: "Tagalog"
  },
  {
    code: "fi",
    name: "Finnish",
    emoji: "🇫🇮",
    native: "Suomi"
  },
  {
    code: "fr",
    name: "French",
    emoji: "🇫🇷",
    native: "Français"
  },
  {
    code: "fy",
    name: "Frisian",
    emoji: "🇳🇱",
    native: "Frysk"
  },
  {
    code: "gl",
    name: "Galician",
    emoji: "🇪🇸",
    native: "Galego"
  },
  {
    code: "ka",
    name: "Georgian",
    emoji: "🇬🇪",
    native: "ქართული"
  },
  {
    code: "de",
    name: "German",
    emoji: "🇩🇪",
    native: "Deutsch"
  },
  {
    code: "el",
    name: "Greek",
    emoji: "🇬🇷",
    native: "Ελληνικά"
  },
  {
    code: "gu",
    name: "Gujarati",
    emoji: "🇮🇳",
    native: "ગુજરાતી"
  },
  {
    code: "ht",
    name: "Haitian Creole",
    emoji: "🇭🇹",
    native: "Krèyol"
  },
  {
    code: "ha",
    name: "Hausa",
    emoji: "🇳🇬",
    native: ""
  },
  {
    code: "haw",
    name: "Hawaiian",
    emoji: "🇺🇸",
    native: "`Ōlelo Hawai`i"
  },
  {
    code: "iw",
    name: "Hebrew",
    emoji: "🇮🇱",
    native: ""
  },
  {
    code: "hi",
    name: "Hindi",
    emoji: "🇮🇳",
    native: "हिन्दी"
  },
  {
    code: "hmn",
    name: "Hmong",
    emoji: "🇱🇦",
    native: "Hmoob"
  },
  {
    code: "hu",
    name: "Hungarian",
    emoji: "🇭🇺",
    native: "Magyar"
  },
  {
    code: "is",
    name: "Icelandic",
    emoji: "🇮🇸",
    native: "Íslenska"
  },
  {
    code: "ig",
    name: "Igbo",
    emoji: "🇳🇬",
    native: ""
  },
  {
    code: "id",
    name: "Indonesian",
    emoji: "🇮🇩",
    native: "Bahasa Indonesia"
  },
  {
    code: "ga",
    name: "Irish",
    emoji: "🇮🇪",
    native: "Gaeilge"
  },
  {
    code: "it",
    name: "Italian",
    emoji: "🇮🇹",
    native: "Italiano"
  },
  {
    code: "ja",
    name: "Japanese",
    emoji: "🇯🇵",
    native: "日本語"
  },
  {
    code: "jw",
    name: "Javanese",
    emoji: "🇮🇩",
    native: ""
  },
  {
    code: "kn",
    name: "Kannada",
    emoji: "🇮🇳",
    native: "ಕನ್ನಡ"
  },
  {
    code: "kk",
    name: "Kazakh",
    emoji: "🇰🇿",
    native: "қазақша"
  },
  {
    code: "km",
    name: "Khmer",
    emoji: "🇰🇭",
    native: "ខ្មែរ"
  },
  {
    code: "rw",
    name: "Kinyarwanda",
    emoji: "🇷🇼",
    native: "Ikinyarwanda"
  },
  {
    code: "ko",
    name: "Korean",
    emoji: "🇰🇷",
    native: "한국어"
  },
  {
    code: "ku",
    name: "Kurdish (Kurmanji)",
    emoji: "🌍",
    native: ""
  },
  {
    code: "ky",
    name: "Kyrgyz",
    emoji: "🇰🇬",
    native: "Кыргызча"
  },
  {
    code: "lo",
    name: "Lao",
    emoji: "🇱🇦",
    native: "ພງສງລງວ"
  },
  {
    code: "la",
    name: "Latin",
    emoji: "🇻🇦",
    native: "lingua latīna"
  },
  {
    code: "lv",
    name: "Latvian",
    emoji: "🇱🇻",
    native: "Latviešu"
  },
  {
    code: "lt",
    name: "Lithuanian",
    emoji: "🇱🇹",
    native: "Lietuvių"
  },
  {
    code: "lb",
    name: "Luxembourgish",
    emoji: "🇱🇺",
    native: "Lëtzebuergesch"
  },
  {
    code: "mk",
    name: "Macedonian",
    emoji: "🇲🇰",
    native: "Македонски"
  },
  {
    code: "mg",
    name: "Malagasy",
    emoji: "🇲🇬",
    native: ""
  },
  {
    code: "ms",
    name: "Malay",
    emoji: "🇲🇾",
    native: "Bahasa Melayu"
  },
  {
    code: "ml",
    name: "Malayalam",
    emoji: "🇮🇳",
    native: "മലയാളം"
  },
  {
    code: "mt",
    name: "Maltese",
    emoji: "🇲🇹",
    native: "Malti"
  },
  {
    code: "mi",
    name: "Maori",
    emoji: "🇳🇿",
    native: "Reo Māori"
  },
  {
    code: "mr",
    name: "Marathi",
    emoji: "🇮🇳",
    native: "मराठी"
  },
  {
    code: "mn",
    name: "Mongolian",
    emoji: "🇲🇳",
    native: "Монгол хэл"
  },
  {
    code: "my",
    name: "Myanmar (Burmese)",
    emoji: "🇲🇲",
    native: "မ္ရန္မာ"
  },
  {
    code: "ne",
    name: "Nepali",
    emoji: "🇳🇵",
    native: "नेपाली"
  },
  {
    code: "no",
    name: "Norwegian",
    emoji: "🇳🇴",
    native: "Norsk"
  },
  {
    code: "or",
    name: "Odia (Oriya)",
    emoji: "🇮🇳",
    native: "ଓଡ଼ିଆ"
  },
  {
    code: "ps",
    name: "Pashto",
    emoji: "🇦🇫",
    native: "پښتو"
  },
  {
    code: "fa",
    name: "Persian",
    emoji: "🇮🇷",
    native: "فارسی"
  },
  {
    code: "pl",
    name: "Polish",
    emoji: "🇵🇱",
    native: "Polski"
  },
  {
    code: "pt",
    name: "Portuguese",
    emoji: "🇵🇹",
    native: "Português"
  },
  {
    code: "pa",
    name: "Punjabi",
    emoji: "🇮🇳",
    native: "ਪੰਜਾਬੀ"
  },
  {
    code: "ro",
    name: "Romanian",
    emoji: "🇷🇴",
    native: "Română"
  },
  {
    code: "ru",
    name: "Russian",
    emoji: "🇷🇺",
    native: "Русский"
  },
  {
    code: "sm",
    name: "Samoan",
    emoji: "🇼🇸",
    native: "le gagana Samoa"
  },
  {
    code: "gd",
    name: "Scots Gaelic",
    emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    native: "Gàidhlig"
  },
  {
    code: "sr",
    name: "Serbian",
    emoji: "🇷🇸",
    native: ""
  },
  {
    code: "st",
    name: "Sesotho",
    emoji: "🇱🇸",
    native: "seSotho"
  },
  {
    code: "sn",
    name: "Shona",
    emoji: "🇿🇼",
    native: "chiShona"
  },
  {
    code: "sd",
    name: "Sindhi",
    emoji: "🇵🇰",
    native: ""
  },
  {
    code: "si",
    name: "Sinhala",
    emoji: "🇱🇰",
    native: "සිංහල"
  },
  {
    code: "sk",
    name: "Slovak",
    emoji: "🇸🇰",
    native: "Slovenčina"
  },
  {
    code: "sl",
    name: "Slovenian",
    emoji: "🇸🇮",
    native: "Slovenščina"
  },
  {
    code: "so",
    name: "Somali",
    emoji: "🇸🇴",
    native: "Soomaali"
  },
  {
    code: "es",
    name: "Spanish",
    emoji: "🇪🇸",
    native: "Español"
  },
  {
    code: "su",
    name: "Sundanese",
    emoji: "🇮🇩",
    native: "Bahasa Sunda"
  },
  {
    code: "sw",
    name: "Swahili",
    emoji: "🇰🇪",
    native: "Kiswahili"
  },
  {
    code: "sv",
    name: "Swedish",
    emoji: "🇸🇪",
    native: "Svenska"
  },
  {
    code: "tg",
    name: "Tajik",
    emoji: "🇹🇯",
    native: "Тоҷикӣ"
  },
  {
    code: "ta",
    name: "Tamil",
    emoji: "🇮🇳",
    native: "தமிழ்"
  },
  {
    code: "tt",
    name: "Tatar",
    emoji: "🇷🇺",
    native: "Татарча"
  },
  {
    code: "te",
    name: "Telugu",
    emoji: "🇮🇳",
    native: "తెలుగు"
  },
  {
    code: "th",
    name: "Thai",
    emoji: "🇹🇭",
    native: "ภาษาไทย"
  },
  {
    code: "tr",
    name: "Turkish",
    emoji: "🇹🇷",
    native: "Türkçe"
  },
  {
    code: "tk",
    name: "Turkmen",
    emoji: "🇹🇲",
    native: "Türkmençe"
  },
  {
    code: "uk",
    name: "Ukrainian",
    emoji: "🇺🇦",
    native: "Українська"
  },
  {
    code: "ur",
    name: "Urdu",
    emoji: "🇵🇰",
    native: "اُردو"
  },
  {
    code: "ug",
    name: "Uyghur",
    emoji: "🇨🇳",
    native: "ﺋۇيغۇر"
  },
  {
    code: "uz",
    name: "Uzbek",
    emoji: "🇺🇿",
    native: "O'zbekcha"
  },
  {
    code: "vi",
    name: "Vietnamese",
    emoji: "🇻🇳",
    native: "Tiếng Việt"
  },
  {
    code: "cy",
    name: "Welsh",
    emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    native: "Cymraeg"
  },
  {
    code: "xh",
    name: "Xhosa",
    emoji: "🇿🇦",
    native: "isiXhosa"
  },
  {
    code: "yi",
    name: "Yiddish",
    emoji: "🇮🇱",
    native: "ייִדיש"
  },
  {
    code: "yo",
    name: "Yoruba",
    emoji: "🇳🇬",
    native: "Yorùbá"
  },
  {
    code: "zu",
    name: "Zulu",
    emoji: "🇿🇦",
    native: "isiZulu"
  }
];
